// extracted by mini-css-extract-plugin
module.exports = {"menuLabel":"MenuLabel__menuLabel___1nYLu","arrow":"MenuLabel__arrow___2bbyJ","open":"MenuLabel__open___2sb59"};